import { render } from "./SalesPage.vue?vue&type=template&id=55010d56&scoped=true&ts=true"
import script from "./SalesPage.vue?vue&type=script&lang=ts"
export * from "./SalesPage.vue?vue&type=script&lang=ts"

import "./SalesPage.vue?vue&type=style&index=0&id=55010d56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55010d56"]])

export default __exports__